import React, { useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { toast } from 'sonner';
import { PaperPlaneRight } from '@phosphor-icons/react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    area: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.post(`${BACKEND_URL}/api/contact`, formData);
      toast.success('Mensagem enviada com sucesso! Entraremos em contato em breve.');
      setFormData({
        name: '',
        phone: '',
        email: '',
        area: '',
        message: ''
      });
    } catch {
      toast.error('Erro ao enviar mensagem. Por favor, tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6" data-testid="contact-form">
      <div>
        <Label htmlFor="name" className="text-[#2A2A2A] font-medium mb-2 block">
          Nome completo
        </Label>
        <Input
          id="name"
          data-testid="contact-name-input"
          type="text"
          required
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          className="rounded-sm border-[#2A2A2A]/20 focus:ring-[#2A2A2A]"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <Label htmlFor="phone" className="text-[#2A2A2A] font-medium mb-2 block">
            Telefone
          </Label>
          <Input
            id="phone"
            data-testid="contact-phone-input"
            type="tel"
            required
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            className="rounded-sm border-[#2A2A2A]/20 focus:ring-[#2A2A2A]"
          />
        </div>

        <div>
          <Label htmlFor="email" className="text-[#2A2A2A] font-medium mb-2 block">
            E-mail
          </Label>
          <Input
            id="email"
            data-testid="contact-email-input"
            type="email"
            required
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            className="rounded-sm border-[#2A2A2A]/20 focus:ring-[#2A2A2A]"
          />
        </div>
      </div>

      <div>
        <Label htmlFor="area" className="text-[#2A2A2A] font-medium mb-2 block">
          Área de interesse
        </Label>
        <Select
          value={formData.area}
          onValueChange={(value) => setFormData({ ...formData, area: value })}
          required
        >
          <SelectTrigger
            id="area"
            data-testid="contact-area-select"
            className="rounded-sm border-[#2A2A2A]/20 focus:ring-[#2A2A2A]"
          >
            <SelectValue placeholder="Selecione a área do caso" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="trabalhista" data-testid="area-option-trabalhista">Direito Trabalhista</SelectItem>
            <SelectItem value="plano-saude" data-testid="area-option-plano-saude">Plano de Saúde</SelectItem>
            <SelectItem value="bpc-loas" data-testid="area-option-bpc-loas">BPC/LOAS</SelectItem>
            <SelectItem value="busca-apreensao" data-testid="area-option-busca-apreensao">Defesa em Busca e Apreensão</SelectItem>
            <SelectItem value="outro" data-testid="area-option-outro">Outro</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label htmlFor="message" className="text-[#2A2A2A] font-medium mb-2 block">
          Mensagem
        </Label>
        <Textarea
          id="message"
          data-testid="contact-message-textarea"
          required
          rows={6}
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
          placeholder="Descreva brevemente a sua situação"
          className="rounded-sm border-[#2A2A2A]/20 focus:ring-[#2A2A2A]"
        />
      </div>

      <Button
        type="submit"
        disabled={isSubmitting}
        data-testid="contact-submit-button"
        className="w-full bg-[#2A2A2A] text-white hover:bg-[#A98C67] rounded-sm transition-colors duration-200 font-medium px-6 py-3"
      >
        {isSubmitting ? (
          'Enviando...'
        ) : (
          <span className="flex items-center justify-center space-x-2">
            <span>Enviar mensagem</span>
            <PaperPlaneRight size={18} weight="bold" />
          </span>
        )}
      </Button>

      <p className="text-xs text-[#999999] text-center">
        Suas informações serão utilizadas exclusivamente para retorno e organização do atendimento inicial.
      </p>
    </form>
  );
};